// extracted by mini-css-extract-plugin
export default {"promo":"promo_promo__ZPQHz","overlay":"promo_overlay__rNf29","bg_img":"promo_bg_img__rLXVC","imgEnter":"promo_imgEnter__1DnlR","imgActive":"promo_imgActive__5Kji4"};